import cloneDeep from "lodash.clonedeep";
import { actions } from "./actions";
import { DEFAULT_STATE } from "./state";
import { mutationTypes, getterTypes } from "./types";

export default {
    actions,
    mutations: {
        [mutationTypes.yieldStart](state) {
            state.isLoading = true;
        },
        [mutationTypes.yieldSuccess](state, data) {
            state.isLoading = false;
            state.data = data.data;
            state.metadata = data.metadata;
            state.csvdata = data.csv;
        },
        [mutationTypes.yieldFailure](state) {
            state.isLoading = false;
        },
    },
    getters: {
        [getterTypes.getYieldData](state) {
            return state.data;
        },
        [getterTypes.getYieldMetadata](state) {
            return state.metadata;
        },
        [getterTypes.getYieldCsvData](state) {
            return state.csvdata;
        },
        [getterTypes.isLoading](state) {
            return state.isLoading;
        },
    },
    state: cloneDeep(DEFAULT_STATE),
};
